import React, { useContext } from "react"
import { Redirect } from "react-router"
import { AuthContext } from "../Auth.js"

function Inicio () {
	const { currentUser } = useContext(AuthContext)
	if (!currentUser){
		return <Redirect to="/login" />
	}
	if (currentUser.rol === 'user') {
	  return <Redirect to="/perfil" />
	} else if (currentUser.rol === 'labInput') {
		return <Redirect to="/Humedad" />
	} else if (currentUser.rol === 'warehouse' || 
		currentUser.role === 'warehouseAdmin' || 
		currentUser.role === 'productPurchase') {
		return <Redirect to="/Inventario-Producto" />
	} else if (currentUser.rol === 'office') {
		return <Redirect to="/Pagos" />
	} else {
		return <Redirect to="/Pendientes" />
	}
}

export default Inicio;
